import { useTranslation } from "react-i18next";
import styled from "styled-components";
import type { OnChangeFn, VisibilityState } from "@tanstack/react-table";
import { Columns3 } from "lucide-react";
import { spacing } from "@styling/sizing";
import { Dropdown } from "../../../components/Dropdown";
import type { ProductColumnLabel } from "./productTableColumns";

const Row = styled.label`
  display: flex;
  align-items: center;
  gap: ${spacing.x1}px;
  padding: ${spacing.x05}px 0;
  cursor: pointer;
`;

const Label = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.x1}px;
`;

interface ColumnVisibilityMenuProps {
  columnLabels: ProductColumnLabel[];
  columnVisibility: VisibilityState;
  onColumnVisibilityChange: OnChangeFn<VisibilityState>;
}

export const ColumnVisibilityMenu = ({
  columnLabels,
  columnVisibility,
  onColumnVisibilityChange,
}: ColumnVisibilityMenuProps) => {
  const { t } = useTranslation();

  const toggle = (id: string, visible: boolean) => {
    onColumnVisibilityChange((previous) => ({ ...previous, [id]: visible }));
  };

  return (
    <Dropdown
      small
      panelWidth={280}
      label={
        <Label>
          <Columns3 size={16} />
          {t("productsView.columns")}
        </Label>
      }
    >
      {columnLabels.map((column) => (
        <Row key={column.id}>
          <input
            type="checkbox"
            checked={columnVisibility[column.id] !== false}
            onChange={(event) => toggle(column.id, event.target.checked)}
          />
          {column.labelKey ? t(column.labelKey) : column.label}
        </Row>
      ))}
    </Dropdown>
  );
};
